import React, { useEffect, useState } from 'react';
import { db } from './firebase';
import { doc, getDoc } from 'firebase/firestore';
import { useLocation} from 'react-router-dom';
import CardDetails from '../../FrontEnd/Integration/CardDetails';
import Spinner from '../../FrontEnd/Integration/Spinner';

function FbDetailsGet() {

  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const path =useLocation()
  const Pathname=path.pathname.split("/")
  
  useEffect(() => {
    let alive = true;


    async function run() {
      setLoading(true);
      setError(null);
      try {
        if (!Pathname[2]|| !Pathname[4]) {
          throw new Error('Parâmetros de rota inválidos.');
        }

        const ref = Pathname
          ? doc(db, 'Db', Pathname[2], Pathname[3], Pathname[4])
          : doc(db, 'Db', Pathname[2], Pathname[3], Pathname[4]);

        const snap = await getDoc(ref);
        if (!snap.exists()) throw new Error('Documento não encontrado.');

        if (alive) setProduct({ id: snap.id, ...snap.data() });
      } catch (e) {
        console.error(e);
        if (alive) setError(e.message || 'Falha ao carregar detalhes.');
      } finally {
        if (alive) setLoading(false);
      }
    }

    run();
    return () => {
      alive = false;
    };
  }, [Pathname[1],Pathname[2],Pathname[3]]);

  if (loading) return <Spinner />;
  if (error) return <div className="p-4 text-red-600">{error}</div>;
  if (!product) return <div className="p-4 text-gray-600">Nenhum detalhe encontrado.</div>;

  return <CardDetails {...product} />;
}

export default FbDetailsGet;